
import "../css/styles.css";

import "../css/AppStateVisual.css";

import { useState, useEffect } from "react";

import { AppState } from "../types/enums";


import { useSessionUpdate } from "../context/SessionContext";

import AtomSpinner from "../common/AtomSpinner";
import { APP_STATE_SPINNER_DISPLAY_MODE, APP_STATE_SPINNER_OPACITY_LEVEL } from "../common/constants";




export default function AppStateVisual() {

  const { getAppState } = useSessionUpdate();
  const [ currentAppState, setCurrentAppState ] = useState<AppState>( AppState.HEALTHY );

  useEffect( () => {
    const intervalId = setInterval( () => {
      const state = getAppState();
      setCurrentAppState( state );
    }, 500 );

    return () => clearInterval( intervalId );
  }, [getAppState]);


  return (
    <>
      {renderAppStateVisual( currentAppState )}
    </>
  );
}


function HealthyState() {
  return <div>Healthy...</div>;
}

function ReadyState() {
  return <div>Ready...</div>;
}

function LoadingState() {
  return <div>Loading...</div>;
}


function ErrorState() {
  return <AtomSpinner displayMode={APP_STATE_SPINNER_DISPLAY_MODE} opacityLevel={APP_STATE_SPINNER_OPACITY_LEVEL} overlayMessage="Error occurred. Retrying..." />
}


function RetryingState() {
  console.log("RENDERING RETRYING STATE");


  return <AtomSpinner displayMode={APP_STATE_SPINNER_DISPLAY_MODE} opacityLevel={APP_STATE_SPINNER_OPACITY_LEVEL} overlayMessage="Retrying..." />

  /*
  return (
    <div className="retrying-overlay">
      <div className="atom-spinner">
        {[...Array(12)].map((_, index) => (
          <div key={index}></div>
        ))}
      </div>
      <div className="retrying-message">Retrying...</div>
    </div>
  );
  */
}





function renderAppStateVisual( appState: AppState ) {

  switch( appState ) {
    case AppState.HEALTHY:
      return null;
    case AppState.READY:
      return null;
    case AppState.ERROR:
      return <ErrorState />;

    case AppState.LOADING:
      return <LoadingState />;
    case AppState.RETRYING:
      return <RetryingState />;
    default:
      return null;
  }

}



